export type { StorySlide, StoryItem } from "../types";
import type { StorySlide, StoryItem } from "../types";

export type QuoteCategory =
  | "Sabar & Tawakkal"
  | "Ilmu & Hikmah"
  | "Akhlak"
  | "Sedekah & Kebaikan"
  | "Doa & Dzikir"
  | "Ibadah & Ramadhan";

export type QuoteSlide =
  | { hook: { title: string; body: string } }
  | { source: { arabic?: string; body: string; title: string } }
  | { reveal: { title?: string; body: string } }
  | { insight: { title?: string; body: string } }
  | { engagement: { title: string; body: string } };

export function createQuoteStory(name: string, emoji: string, slides: QuoteSlide[]): StorySlide[] {
  return slides.map((slide) => {
    if ("hook" in slide) return { type: "hook", title: slide.hook.title, body: slide.hook.body };
    if ("source" in slide) return { type: "source", arabic: slide.source.arabic, body: slide.source.body, title: slide.source.title };
    if ("reveal" in slide) return { type: "reveal", title: slide.reveal.title ?? `${emoji} ${name}`, body: slide.reveal.body };
    if ("insight" in slide) return { type: "insight", title: slide.insight.title, body: slide.insight.body };
    return { type: "engagement", title: slide.engagement.title, body: slide.engagement.body };
  });
}

export interface Quote extends StoryItem {
  category: QuoteCategory;
}
